module.exports = __webpack_public_path__ + "static/media/DMembers.4937f018.png";